import { render, staticRenderFns } from "./pruebasCourse.vue?vue&type=template&id=afae048a&scoped=true"
import script from "./pruebasCourse.vue?vue&type=script&lang=js"
export * from "./pruebasCourse.vue?vue&type=script&lang=js"
import style0 from "./pruebasCourse.vue?vue&type=style&index=0&id=afae048a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afae048a",
  null
  
)

export default component.exports